import type { ComponentPropsWithRef, ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type SkeletonProps = ComponentPropsWithRef<'span'>;

/** Pulsing placeholder bar. Size and shape come from the caller: `h-3 w-28` for a line, `rounded-full` for an avatar. */
export function Skeleton({ className, ...props }: SkeletonProps): ReactElement {
    return (
        <span
            data-slot="skeleton"
            aria-hidden
            className={cn('rounded-tight bg-content-weakest block h-3 animate-pulse', className)}
            {...props}
        />
    );
}
